import React from "/vendor/react";
import PropTypes from "prop-types";
import gql from "/vendor/graphql-tag";

import { Grid } from "/vendor/@material-ui/core";

import { Content, Loader } from "/lib/component/base";

import Configuration from "./HandlerDetailsConfiguration";
import Toolbar from "./HandlerDetailsToolbar";

const HandlerDetailsContainer = ({
  handler,
  loading,
  toolbarItems,
  onClickEdit,
  onClickDelete,
}) => (
  <Loader loading={loading} passthrough>
    {handler && (
      <React.Fragment>
        <Content marginBottom>
          <Toolbar
            handler={handler}
            toolbarItems={toolbarItems}
            onClickEdit={onClickEdit}
            onClickDelete={onClickDelete}
          />
        </Content>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Configuration handler={handler} />
          </Grid>
        </Grid>
      </React.Fragment>
    )}
  </Loader>
);

HandlerDetailsContainer.propTypes = {
  handler: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  toolbarItems: PropTypes.func,
  onClickEdit: PropTypes.func,
  onClickDelete: PropTypes.func,
};

HandlerDetailsContainer.defaultProps = {
  handler: null,
  toolbarItems: undefined,
  onClickEdit: () => null,
  onClickDelete: () => null,
};

HandlerDetailsContainer.fragments = {
  handler: gql`
    fragment HandlerDetailsContainer_handler on Handler {
      id
      deleted @client

      ...HandlerDetailsConfiguration_handler
    }

    ${Configuration.fragments.handler}
  `,
};

export default HandlerDetailsContainer;
